module.exports = __webpack_public_path__ + "static/whitebunnysuitcase-66fb6f7a241edb3d34c39b03b6b8fcb8.jpeg";